import { ITEMS_BOOSTERS_CATEGORIES, ITEMS_RARITY, ItemTemplate } from "../constants";

export default {
    type: "boosters",
    listData: [{
        "key": "name",
        "label": "Name",
    }, {
        "key": "rarity",
        "label": "Rarity",
    }, {
        "key": "seconds",
        "label": "Reduce time in seconds",
    }, {
        "key": "price",
        "label": "Price",
    }],
    template: [{
        "key": "name",
        "label": "Name",
        "type": "input",
    }, {
        "key": "game_id",
        "label": "Game Id",
        "type": "input",
        "format": "integer"
    }, {
        "key": "amount",
        "label": "Pack amount",
        "type": "input",
        "format": "integer"
    }, {
        "key": "seconds",
        "label": "Reduce time in seconds",
        "type": "input",
        "format": "integer",
        "disabled": true,
    }, {
        "key": "price",
        "label": "Price",
        "type": "input",
        "format": "integer"
    }, {
        "key": "group",
        "label": "Type",
        "type": "select",
        "values": ITEMS_BOOSTERS_CATEGORIES
    }, {
        "key": "rarity",
        "label": "Rarity",
        "type": "select",
        "values": ITEMS_RARITY
    }]
} as ItemTemplate;
